// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.codeInput[data-v-f620f1a8],.el-input[data-v-f620f1a8]{\n    width: 200px;\n}\n.el-form-item[data-v-f620f1a8] .el-form-item__label{\n    width: 120px !important;justify-content: flex-start;\n}\n", ""]);
// Exports
module.exports = exports;
